export default {
  shareeEmail: {
    component: "TextFieldSearchFilter",
  },
  camera: {
    component: "TextFieldSearchFilter",
    isGlobalFilter: true,
    attributes: {
      label: "Camera Name",
    },
  },
  sharer: {
    component: "TextFieldSearchFilter",
    isGlobalFilter: true,
    attributes: {
      label: "Camera Sharer",
    },
  },
}
